<div class="user-points-box">
  <p>User Points: {{ userPoints }}</p>
</div>

<!-- Main dashboard content goes here -->
<h2>Referral link</h2>
<p>Your referral link is: 
  <a href="http://localhost:4200/session/register?referredBy={{ referral_hash }}">
    http://localhost:4200/session/register?referredBy={{ referral_hash }}
  </a>
</p>